import React from 'react'
import styled, { css } from 'styled-components'

interface Props {
  bgColor?: string
  bgGradient?: gradientVariants | null
  variant?: cardVariants
  shadow?: boolean
  border?: boolean
  padding?: string
  mobilePadding?: string
  minHeight?: string
  className?: string
}

type cardVariants = 'normal' | 'deckPurple'
type gradientVariants =
  | 'verdeblu'
  | 'verde'
  | 'blu'
  | 'rosso'
  | 'aranciogiallo'
  | 'grigioestra'

export const Card: React.FC<Props> = ({
  variant,
  bgColor,
  bgGradient,
  shadow,
  border,
  padding,
  minHeight,
  mobilePadding,
  children,
  className,
}) => {
  return (
    <Wrapper
      variant={variant}
      bgColor={bgColor}
      bgGradient={bgGradient}
      shadow={shadow}
      border={border}
      minHeight={minHeight}
      padding={padding}
      mobilePadding={mobilePadding}
      className={className}
    >
      {children}
    </Wrapper>
  )
}

interface WrapperProps {
  variant?: cardVariants
  bgColor?: string
  bgGradient?: gradientVariants | null
  shadow?: boolean
  border?: boolean
  minHeight?: string
  padding?: string
  mobilePadding?: string
}

const getVariant = ({ variant }: WrapperProps) => {
  switch (variant) {
    case 'deckPurple':
      return css`
        border-radius: 20px 20px 5px 5px;
        border-bottom: 8px solid ${({ theme }) => theme.color.primari.viola};
      `

    default:
      return css`
        border-radius: 20px 20px 20px 20px;
      `
  }
}

const getGradientVariant = ({ bgGradient }: WrapperProps) => {
  switch (bgGradient) {
    case 'verdeblu':
      return css`
        background: linear-gradient(358.5deg, #83d200 -20.46%, #00b0ff 91.8%);
      `

    case 'blu':
      return css`
        background: linear-gradient(133.15deg, #01579b -1.28%, #00b0ff 72.43%);
      `

    case 'verde':
      return css`
        background: linear-gradient(156.8deg, #1b5e20 -9.92%, #83d200 102.65%);
      `

    case 'rosso':
      return css`
        background: linear-gradient(156.8deg, #963131 -9.92%, #ff6666 102.65%);
      `
    case 'aranciogiallo':
      return css`
        background: linear-gradient(156.8deg, #bb5a00 -9.92%, #ffd427 102.65%);
      `
    case 'grigioestra':
      return css`
        background: linear-gradient(156.8deg, #0e1a2f -9.92%, #606876 102.65%);
      `

    default:
      return css``
  }
}

const Wrapper = styled.div<WrapperProps>`
  background-color: ${({ bgColor }) => bgColor || 'white'};
  padding: ${({ mobilePadding, padding }) =>
    mobilePadding || padding || '2rem'};

  box-shadow: ${({ theme, shadow }) => (shadow ? theme.shadow.espansa : '')};
  border: ${({ theme, border }) =>
    border ? `2px solid ${theme.color.neutri.grigioBg};` : ''};

  min-height: ${({ minHeight }) => minHeight ?? null};

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    padding: ${({ padding }) => padding || '2rem'};
  }

  ${getVariant};

  ${getGradientVariant};
`
